import qs from 'qs';
import { axiosAPI } from '@/axios';

const loadscheduleTemplates = (filter) => {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAPI.get(`/daily-schedule-templates${query}`);
  }
  return axiosAPI.get('/daily-schedule-templates');
};

const loadScheduleTemplateById = (templateId) => {
  return axiosAPI.get(`/daily-schedule-templates/${templateId}`);
};

const createScheduleTemplate = (newTemplate) => {
  return axiosAPI.post('/daily-schedule-templates', newTemplate);
};

const updateScheduleTemplateById = (templateId, newTemplate) => {
  return axiosAPI.put(`/daily-schedule-templates/${templateId}`, newTemplate);
};

const deleteScheduleTemplate = (templateId) => {
  return axiosAPI.delete(`/daily-schedule-templates/${templateId}`);
};


export {
  loadscheduleTemplates,
  loadScheduleTemplateById,
  createScheduleTemplate,
  updateScheduleTemplateById,
  deleteScheduleTemplate,
};
